const counters = document.querySelectorAll<HTMLElement>('.numero-valor[data-count]')

if (counters.length) {
  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue

        const el = entry.target as HTMLElement
        const target = parseInt(el.dataset.count ?? '0', 10)
        const prefix = el.dataset.prefix ?? ''
        const suffix = el.dataset.suffix ?? ''
        const duration = target <= 10 ? 800 : 2000
        const start = performance.now()

        const animate = (now: number) => {
          const progress = Math.min((now - start) / duration, 1)
          const eased = 1 - Math.pow(1 - progress, 3)
          const current = progress < 1 ? Math.round(eased * target) : target
          el.textContent = prefix + current.toLocaleString('pt-BR') + suffix
          if (progress < 1) {
            requestAnimationFrame(animate)
          }
        }

        requestAnimationFrame(animate)
        observer.unobserve(el)
      }
    },
    { threshold: 0.2 },
  )

  for (const counter of counters) observer.observe(counter)
}
